import { render, staticRenderFns } from "./tokusho.vue?vue&type=template&id=3e5c7ba2&scoped=true&"
import script from "./tokusho.vue?vue&type=script&lang=js&"
export * from "./tokusho.vue?vue&type=script&lang=js&"
import style0 from "./tokusho.vue?vue&type=style&index=0&id=3e5c7ba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5c7ba2",
  null
  
)

export default component.exports